import React, { useState } from 'react';
import type { RetainedContentProps } from './types';

/**
 * Hides its children without unmounting them once they have been shown, so a modal opened from them
 * keeps its state while the content is replaced by a loading placeholder. Never mounts them while
 * hidden for the first time.
 */
export const RetainedContent: React.FC<RetainedContentProps> = ({ hidden, children }) => {
    const [shown, setShown] = useState(!hidden);
    if (!hidden && !shown) setShown(true);

    return hidden && !shown ? null : <div hidden={hidden}>{children}</div>;
};
